/**
 * @generated SignedSource<<b8d4e42865596cb0b73d9b1b2df8e7ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type persologElementQuestionFormDialog_QuestionFragment$data = {
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionForm_QuestionFragment">;
  readonly " $fragmentType": "persologElementQuestionFormDialog_QuestionFragment";
};
export type persologElementQuestionFormDialog_QuestionFragment$key = {
  readonly " $data"?: persologElementQuestionFormDialog_QuestionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionFormDialog_QuestionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "persologElementQuestionFormDialog_QuestionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "persologElementQuestionForm_QuestionFragment"
    }
  ],
  "type": "Persolog_Question",
  "abstractKey": null
};

(node as any).hash = "472218f52c6fa4b6e17d1891f14f5531";

export default node;
